module.exports = __webpack_public_path__ + "img/kjjh_gallery9.26b1c3d7.jpg";